export default "__VITE_ASSET__9eca5fb7__"